var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "form relative" }, [
    _c(
      "form",
      {
        ref: "form",
        class: [
          "flex",
          "flex-col",
          "items-start",
          "mb-0",
          "md:mb-32",
          { "opacity-0": _vm.submitted }
        ],
        attrs: { id: "contact-form", method: "POST", name: "leasing" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.checkForm($event)
          }
        }
      },
      [
        _c("input", {
          attrs: { type: "hidden", name: "form-name", value: "leasing" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input flex flex-col relative mb-6 w-full" }, [
          _c(
            "label",
            {
              class: [
                "text-lg",
                "font-body",
                "text-gray-400",
                { active: _vm.hasValue(_vm.form.subject) }
              ],
              attrs: { for: "subject" }
            },
            [_vm._v("Subject")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.subject,
                expression: "form.subject"
              }
            ],
            staticClass:
              "h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2",
            attrs: {
              type: "text",
              name: "subject",
              "data-error": _vm.errors.subject
            },
            domProps: { value: _vm.form.subject },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "subject", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input flex flex-col relative mb-6 w-full" }, [
          _c(
            "label",
            {
              class: [
                "text-lg",
                "font-body",
                "text-gray-400",
                { active: _vm.hasValue(_vm.form.name) }
              ],
              attrs: { for: "name" }
            },
            [_vm._v("Name")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.name,
                expression: "form.name"
              }
            ],
            staticClass:
              "h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2",
            attrs: {
              type: "text",
              name: "name",
              "data-error": _vm.errors.name
            },
            domProps: { value: _vm.form.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "name", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input flex flex-col relative mb-6 w-full" }, [
          _c(
            "label",
            {
              class: [
                "text-lg",
                "font-body",
                "text-gray-400",
                { active: _vm.hasValue(_vm.form.email) }
              ],
              attrs: { for: "email" }
            },
            [_vm._v("E-mail")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.email,
                expression: "form.email"
              }
            ],
            staticClass:
              "h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2",
            attrs: {
              type: "email",
              name: "email",
              "data-error": _vm.errors.email
            },
            domProps: { value: _vm.form.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "email", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input flex flex-col relative mb-6 w-full" }, [
          _c(
            "label",
            {
              class: [
                "text-lg",
                "font-body",
                "text-gray-400",
                { active: _vm.hasValue(_vm.form.phone) }
              ],
              attrs: { for: "phone" }
            },
            [_vm._v("Phone")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form.phone,
                expression: "form.phone"
              }
            ],
            staticClass:
              "h-12 font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2",
            attrs: { type: "tel", name: "phone" },
            domProps: { value: _vm.form.phone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.form, "phone", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input flex flex-col relative mb-18 md:mb-16 w-full" },
          [
            _c(
              "label",
              {
                staticClass: "text-lg font-body",
                class: [
                  "text-lg",
                  "font-body",
                  "text-gray-400",
                  { active: _vm.hasValue(_vm.form.comments) }
                ],
                attrs: { for: "comments" }
              },
              [_vm._v("Comments")]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.comments,
                  expression: "form.comments"
                }
              ],
              staticClass:
                "font-body font-normal border-b border-gray-200 hover:border-gray-500 focus:border-gray-800 text-2xl p-2 h-28",
              attrs: { name: "comments", "data-error": _vm.errors.comments },
              domProps: { value: _vm.form.comments },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.form, "comments", $event.target.value)
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "text-white px-8 py-4 text-lg leading-6 font-body",
            class: [_vm.valid ? "bg-gray-800" : "bg-gray-300"],
            attrs: { type: "submit", disabled: !_vm.valid }
          },
          [_vm._v("Submit")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.submitted,
            expression: "submitted"
          }
        ],
        staticClass: "success center absolute top-0 left-0"
      },
      [_c("h3", [_vm._v("The form has been submitted.")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }